import { useFm, useParams } from '@web3/base-hooks';
import { Block } from '../../components/block';
import { TokenCard } from './tokenCard';
import styles from './index.module.scss';

const HIDDEN_LIST: {
  [key: string]: string[];
} = {
  IDO: ['en-NL', 'nl-NL'],
};

export const ImportantTokens = () => {
  const { locale } = useParams();
  const fm = useFm();
  const tokenCardArr = [
    {
      tagBgColor: '#62F707',
      tagTitle: 'AirDrop',
      title: fm('getWeb3RewardsDaily'),
      desc: fm('getWeb3RewardsEve'),
      url: `/${locale}/web3/airdrop?tab=activity`,
      appUrl: 'by-mini://web3_applet/metropolis2',
    },
    {
      tagBgColor: '#F7A600',
      tagTitle: 'Earn',
      title: fm('upTo30PercentApy'),
      desc: fm('earnPassiveIncome'),
      url: `/${locale}/web3/staking`,
      appUrl: 'by-mini://earn/earnHome',
    },
  ].filter((item) => !HIDDEN_LIST[item.tagTitle]?.includes(locale ?? ''));

  return (
    <Block clsName={styles.itsContainerWrapper} noHeader>
      <div className={styles.its_container}>
        <div className={styles.its_container_title}>
          {fm('firstAccessTokens')}
        </div>
        <div className={styles.its_container_body}>
          {tokenCardArr.map((item, index) => (
            <TokenCard key={index} {...item} />
          ))}
        </div>
      </div>
    </Block>
  );
};
